<ng-container *transloco="let t">
  <div class="mb-4 text-sm font-medium tracking-tight text-gray-700">
    {{ t("dashboard360.unsaved_changes_modal_desc") }}
  </div>

  <div class="flex justify-end gap-2">
    <button iButton variant="warning" size="sm" (click)="modalRef.close(false)">
      {{ t("dashboard360.discard_changes") }}
    </button>
    <button iButton size="sm" (click)="modalRef.close(true)">{{ t("common.save") }}</button>
  </div>
</ng-container>
